import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/bet777/images/footer/logoFooter.png';

export default function index() {
  return <Image src={footerLogo} minW="140px" maxW="201px" minH="34px" />;
}
